import { createContext, useReducer } from 'react'

export const ChatContext = createContext()

export const ChatContextProvider = ({ children }) => {
  const INITIAL_STATE = {
    groupId: 'null',
    groupName: 'null',
  }

  const chatReducer = (state, action) => {
    switch (action.type) {
      case 'CHANGE_GROUP':
        return {
          groupId: action.payload[0],
          groupName: action.payload[1].groupInfo.groupName,
        }

      default:
        return state
    }
  }

  const [state, dispatch] = useReducer(chatReducer, INITIAL_STATE)

  return (
    <ChatContext.Provider value={{ data: state, dispatch }}>
      {children}
    </ChatContext.Provider>
  )
}
